export default {
    accounts_tab_id: 'Id',
    accounts_tab_name: 'Name',
    accounts_tab_dealer: 'Dealer',
    accounts_tab_brand: 'Brand',
    accounts_tab_status: 'Status',
    accounts_tab_companies: 'Companies',
    accounts_tab_accounts: 'Accounts',
    accounts_tab_advanced_filters: 'Advanced Filters',
    accounts_tab_apply: 'Apply',
    accounts_tab_tags: 'Tags',
    accounts_tab_active_accounts_only: 'Active Accounts Only',
    accounts_tab_yes: 'Yes',
    accounts_tab_no: 'No',
    accounts_tab_authenticate_cloud: 'Login as Customer',
    accounts_tab_re_sync_backend_information: 'Re-sync Backend Information',
    accounts_tab_devices: 'Devices',
    accounts_tab_package: 'Package',
    accounts_tab_crm: 'Salesforce Id',
    accounts_tab_add_account: 'Add Account',
    accounts_tab_edit: 'Edit',
    accounts_tab_remove_filters: 'Remove filters',
    accounts_tab_account_details: 'Account Details',
    accounts_tab_import_from_p4: 'Import From P4',
    accounts_tab_reprocess_odo_hours: 'Reprocess Odo/Hrs',
    accounts_tab_new_status: 'New Status',
    accounts_tab_at: 'at',
    accounts_tab_next_scheduled_action: 'Next scheduled action on',
    accounts_tab_on: 'on'
};



